import * as React from "react"
import {IconSeeker} from "@ui-seeker/core";
import {Box, Link} from "@mui/material";

import { LinkIconBlock } from "@components";


export default function keywordColumn() {
	return {
		name: 'keyword', label: 'Keyword',
		options: {
            customBodyRowRenderLite: (value, { pageURL }) => {
				return <Box display={"flex"} justifyContent={"center"}>
					{ !!value && <LinkIconBlock
						url={pageURL}
						children={value}
						linkProps={{ sx: {color: 'text.disabled', fontSize: '1.5 rem'}}}
						textProps={{ sx: { fontSize: '0.9rem'}}}
					/> }
				</Box>
			}
        }
	}
}